<template>
  <div class="module-add-container">
    <div class="module-title">已有模块</div>
    <Draggable
      class="module-list"
      :list="list"
      :options="{ animation: 200, ghostClass: 'ghost' }"
      @change="draggableChange"
    >
      <div
        v-for="item in list"
        :key="item.id || item.type"
        class="module-item"
      >
        <div class="module-item-title">
          <i class="iconfont icontiaoxu"></i>
          {{ item.title }}
        </div>
        <div class="module-icons">
          <i
            class="iconfont iconedit-"
            @click="clickEditModuleName(item)"
          ></i>
          <i
            class="iconfont iconshanchujianli"
            @click="clickDeleteModule(item)"
          ></i>
        </div>
      </div>
    </Draggable>
    <div
      class="module-title"
      style="margin-top: 24px"
    >
      添加模块
    </div>
    <div class="module-list">
      <div
        v-for="(item, index) in notAddModuleList"
        :key="index"
        class="module-item"
        @click="clickAddModule(item)"
      >
        <div class="module-item-title">
          <i class="iconfont iconxinjianjianli"></i>
          {{ item[`${cvDetail.basic_info.lang}_default_name`] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Draggable from 'vuedraggable';
import { debounce } from '@/assets/js/util';
import { menu } from '@/assets/js/manage';
export default {
  name: 'ModuleAdd',
  components: {
    Draggable,
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail']),
    notAddModuleList() {
      return menu.filter((item) => !this.list.some((k) => k.type === item.type) || item.type === 'custom');
    },
  },
  methods: {
    async clickAddModule(item) {
      if (['sample', 'template'].includes(this.cvDetail.basic_info.kind)) {
        this.$message.info('请先完善简历内容');
        return;
      }
      let customId = null;
      this.$emit('changeSaveLoading', true);
      switch (item.type) {
        case 'opus':
        case 'works':
        case 'orgs':
        case 'edus':
          // this.$store.commit('editor/setModuleData', {
          //   type: item.type,
          //   info: [
          //     {
          //       id: `${item.type}-edit`,
          //       company: '',
          //       title: '',
          //       name: '',
          //       dept: '',
          //       description: '',
          //       qrcode: '',
          //       start_at: '',
          //       end_at: '',
          //       present: '',
          //       url: '',
          //     },
          //   ],
          // });
          await this.$store.dispatch('editor/updateCvDetail', {
            // ...this.cvDetail,
            submodule_info: {
              ...this.cvDetail.submodule_info,
              sections_position: [
                ...this.cvDetail.submodule_info.sections_position,
                {
                  type: item.type,
                  id: null,
                  info_ids: [],
                },
              ],
              [`${item.type}_title`]: item[`${this.cvDetail.basic_info.lang}_default_name`],
            },
            operation_type: 'update_submodule_info',
            skipCheck: true,
          });
          this.initCurrentModuleList();
          this.$emit('changeSaveLoading', false);
          // this.$emit('editItem', `${item.type}-edit`);
          break;
        case 'extras':
          this.$store.commit('editor/setModuleData', {
            type: 'extras',
            info: {
              skill: {
                name: '技能',
                description: null,
              },
              language: {
                name: '语言',
                description: null,
              },
              other: {
                name: '活动',
                description: null,
              },
              interest: {
                name: '兴趣',
                description: null,
              },
              certificate: {
                name: '证书/执照',
                description: null,
              },
            },
          });
          await this.$store.dispatch('editor/updateCvDetail', {
            // ...this.cvDetail,
            submodule_info: {
              ...this.cvDetail.submodule_info,
              sections_position: [
                ...this.cvDetail.submodule_info.sections_position,
                {
                  type: 'extras',
                  id: null,
                  info_ids: [],
                },
              ],
              extras_title: item[`${this.cvDetail.basic_info.lang}_default_name`],
            },
            operation_type: 'update_submodule_info',
            skipCheck: true,
          });
          this.initCurrentModuleList();
          this.$emit('changeSaveLoading', false);
          // this.$emit('editItem', 'extras-edit');
          break;
        default:
          try {
            // 先创建自定义大模块
            const res = await this.$store.dispatch('editor/createCustom', {
              category: item.type === 'custom' ? null : item.type,
              section_title: item[`${this.cvDetail.basic_info.lang}_default_name`],
              lang: this.cvDetail.basic_info.lang || 'cn',
              cv_token: this.cvDetail.basic_info.token,
              displayLoading: false,
            });
            if (res.code === 1000) {
              // this.$store.commit('editor/setModuleData', {
              //   type: item.type === 'custom' ? res.data.custom_section.id : item.type,
              //   info: [
              //     {
              //       custom_section_id: res.data.custom_section.id,
              //       id: `${res.data.custom_section.id}-edit`,
              //       title: '',
              //       name: '',
              //       dept: '',
              //       description: '',
              //       start_at: '',
              //       end_at: '',
              //       present: '',
              //     },
              //   ],
              // });
              await this.$store.dispatch('editor/updateCvDetail', {
                // ...this.cvDetail,
                submodule_info: {
                  ...this.cvDetail.submodule_info,
                  sections_position: [
                    ...this.cvDetail.submodule_info.sections_position,
                    {
                      type: item.type,
                      id: res.data.custom_section.id,
                      info_ids: [],
                    },
                  ],
                  custom_sections_ids: [...this.cvDetail.submodule_info.custom_sections_ids, res.data.custom_section.id],
                  custom_sections_titles: {
                    ...this.cvDetail.submodule_info.custom_sections_titles,
                    [`${res.data.custom_section.id}_title`]: item[`${this.cvDetail.basic_info.lang}_default_name`],
                  },
                },
                operation_type: 'update_submodule_info',
                skipCheck: true,
              });
              this.initCurrentModuleList();
              if (item.type === 'custom') {
                customId = res.data.custom_section.id;
                this.$store.commit('editor/setModuleData', {
                  type: res.data.custom_section.id,
                  info: [],
                });
              }
            }
            this.$emit('changeSaveLoading', false);
          } catch (error) {
            console.log(error);
          }
          break;
      }

      const id = item.type === 'custom' ? customId : item.type;
      const el = document.getElementById(`sectionModule${id}`);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    clickEditModuleName(item) {
      this.$emit('clickEditModuleName', item);
    },
    clickDeleteModule(item) {
      this.$emit('clickDeleteModule', item);
    },
    initCurrentModuleList() {
      const { submodule_info = {} } = this.cvDetail;
      const { sections_position, custom_sections_titles } = submodule_info;
      this.list = sections_position.map((item) => {
        const title = submodule_info[`${item.type}_title`] || custom_sections_titles[`${item.id}_title`];
        return {
          ...item,
          title,
        };
      });
    },
    draggableChange: debounce(function () {
      try {
        const sections_position = this.list.map((item) => {
          const { title, ...rest } = item;
          return rest;
        });
        const submodule_info = {
          ...this.cvDetail.submodule_info,
          sections_position,
        };

        if (['sample', 'template'].includes(this.cvDetail.basic_info.kind)) {
          this.$store.commit('editor/setCvDetail', {
            ...this.cvDetail,
            submodule_info,
          });
          return;
        }

        this.$store.dispatch('editor/updateCvDetail', {
          submodule_info,
          operation_type: 'update_submodule_info',
          skipCheck: true,
        });
      } catch (error) {
        console.log(error);
      }
    }, 300),
  },
  mounted() {
    this.initCurrentModuleList();
  },
};
</script>
<style lang="scss" scoped>
.module-add-container {
  position: absolute;
  top: 36px;
  right: 0;
  width: 304px;
  background-color: #1f232a;
  border-radius: 8px;
  border: 1px solid #383e49;
  backdrop-filter: blur(8px);
  padding: 20px;
  box-sizing: border-box;
  .module-title {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    margin-bottom: 16px;
  }
  .module-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    .module-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      background-color: #383e49;
      border-radius: 6px;
      padding: 0 12px;
      .module-item-title {
        display: flex;
        align-items: center;
        color: #fff;
        .iconfont {
          color: #8d99aa;
          margin-right: 12px;
          &.iconxinjianjianli {
            color: #fff;
          }
        }
      }
      .module-icons {
        display: flex;
        align-items: center;
        .iconfont {
          font-size: 14px;
          &:not(:last-child) {
            margin-right: 12px;
          }
        }
      }
    }
  }
}
</style>
